import SaveStateButton from '../general/SaveStateButton'
import config from '../../config.json'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import RequestOverlayContainer from '../overlay/container/RequestOverlayContainer'
import FormWeischerData from './FormWeischerData'
import WrapperAccordion from '../general/WrapperAccordion'
import Button from '../general/Button'
import { WEISCHER_INTERSCROLLER, WEISCHER_OVERVIEW, WEISCHER_OVERVIEW_HERO, WEISCHER_PREROLL } from '../../constants/weischerTypes'
import Translation from '../Translation/cont/Translation'

const PageWeischerPage = ({programStatus, programError, items, onUpdateItem, addItem, onUpdateProgram, cliCinemas, clientCinemaId, weischerConfig, closePagePath}) => {
    if(!weischerConfig) {
        return ''
    }

    const { weischer_interscroller, weischer_overview, weischer_overview_hero, weischer_preroll } = weischerConfig

    const filterForWeischerItems = (itemType) => {
        return _.filter(items, item => {
            return item.type === itemType
        })
    }

    const prerollItems = filterForWeischerItems(WEISCHER_PREROLL)
    const overviewItems = filterForWeischerItems(WEISCHER_OVERVIEW)
    const overviewHeroItems = filterForWeischerItems(WEISCHER_OVERVIEW_HERO)
    const interscrollerItems = filterForWeischerItems(WEISCHER_INTERSCROLLER)

    return (
        <WrapperPageSimple
            pageTitleTransId={config.routes.weischer.transId}
            closePagePath={closePagePath}
            overlay={
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />}
        >
            <div className="program-page site-content">
                <WrapperAccordion
                    className="single-section"
                    selectionActiveClass="accordion-item-open">
                    <div className="form-content weischer">
                        {weischer_preroll && <div className="left-sections">
                            <p className="title-large-light">PREROLL</p>
                            <div className="weischer-preroll-items-wrapper">
                                {prerollItems.map((item, index) => {
                                    return <FormWeischerData onUpdateItem={onUpdateItem} item={item} type={WEISCHER_PREROLL} key={index} cliCinemas={cliCinemas} clientCinemaId={clientCinemaId}/>
                                })}
                            </div>
                            {prerollItems.length === 0 && <Button
                                className="button-add"
                                transId="weischer_button_new_ad_element_preroll"
                                onClick={addItem}
                                adItemType={WEISCHER_PREROLL}
                                hideText={false}
                            />}
                        </div>}
                        <div className="right-sections">
                            {weischer_overview && <div className="weischer-overview-items-wrapper">
                                <p className="title-large-light"><Translation id="weischer_title_program_overview_tiles">PROGRAMMÜBERSICHT KACHELN</Translation></p>
                                {overviewItems.map((item, index) => {
                                    return <FormWeischerData onUpdateItem={onUpdateItem} item={item} type={WEISCHER_OVERVIEW} key={index} cliCinemas={cliCinemas} clientCinemaId={clientCinemaId}/>
                                })}
                            </div>}
                            {weischer_overview && overviewItems.length < 3  && <Button
                                className="button-add"
                                transId="weischer_button_new_ad_element_program_overview"
                                onClick={addItem}
                                adItemType={WEISCHER_OVERVIEW}
                                hideText={false}
                            />}
                            {weischer_overview_hero && <div className="weischer-overview-items-wrapper">
                                <p className="title-large-light"><Translation id="weischer_title_program_overview_hero">PROGRAMMÜBERSICHT HERO BANNER</Translation></p>
                                {overviewHeroItems.map((item, index) => {
                                    return <FormWeischerData onUpdateItem={onUpdateItem} item={item} type={WEISCHER_OVERVIEW_HERO} key={index} cliCinemas={cliCinemas} clientCinemaId={clientCinemaId}/>
                                })}
                            </div>}
                            {weischer_overview_hero && overviewHeroItems.length === 0  && <Button
                                className="button-add"
                                transId="weischer_button_new_ad_element_hero"
                                onClick={addItem}
                                adItemType={WEISCHER_OVERVIEW_HERO}
                                hideText={false}
                            />}
                            {weischer_interscroller && <div className="weischer-overview-items-wrapper">
                                <p className="title-large-light"><Translation id="weischer_title_program_overview_interscroller">PROGRAMMÜBERSICHT INTERSCROLLER</Translation></p>
                                {interscrollerItems.map((item, index) => {
                                    return <FormWeischerData onUpdateItem={onUpdateItem} item={item} type={WEISCHER_INTERSCROLLER} key={index} cliCinemas={cliCinemas} clientCinemaId={clientCinemaId}/>
                                })}
                            </div>}
                            {weischer_interscroller && interscrollerItems.length === 0  && <Button
                                className="button-add"
                                transId="weischer_button_new_ad_interscroller"
                                onClick={addItem}
                                adItemType={WEISCHER_INTERSCROLLER}
                                hideText={false}
                            />}
                        </div>
                    </div>
                </WrapperAccordion>
                <div className="save-program-button">
                    <SaveStateButton
                        status={programStatus}
                        transId="update_button"
                        condition={true}
                        saveState={onUpdateProgram}
                    />
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default PageWeischerPage